import isString from 'lodash/isString';

type Message = string | Record<string, string | undefined>;

const localize = (m: Message, locale = '', defaultLocale = 'en') => {
  if (isString(m)) {
    return m;
  }
  if (!Object.keys(m || {}).length) {
    return '';
  }
  const someLocale = Object.keys(m).find((l) => m[l]);
  return (locale ? m[locale] : undefined)
    || m[defaultLocale]
    || m.de
    || m.fr
    || m.it
    || m.nl
    || (someLocale ? m[someLocale] : '');
};

export default localize;
